export function useCalendarGridWeekCellHandlers({
  day,
  hour,
  isDisabled,
  isPast,
  start,
  onClick,
  onPointerDown,
  onPointerEnter,
}) {
  function handleClick() {
    if (!isDisabled) {
      onClick(start)
    }
  }

  function handlePointerDown() {
    if (!isPast) {
      onPointerDown({ day, hour })
    }
  }

  function handlePointerEnter() {
    if (!isPast) {
      onPointerEnter({ day, hour })
    }
  }

  return {
    handleClick,
    handlePointerDown,
    handlePointerEnter,
  }
}
